module.exports = __webpack_public_path__ + "img/print-logo.6a942a06.png";